import PollsModel from '../Apis/Polls'
import Controller from './Controller'

export default class PollsController extends Controller {
  constructor() {
    super(new PollsModel())
  }
  async GetPoll(id) {
    try {
      const response = await this.model.GetPoll(id);
      console.log(response.data);

      return response.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async SetPoll( data) {
    const res = await this.model.SetPoll( data)
    return this.Poup(res);
  }
}
